export default function SearchItemBarometerButton({ isItemPriceBelowAnnual, onPress }) {

    return (

        <div className="flight-price__info">
            <a type="button" className="flight-price__graph-link" onClick={onPress}>
                {isItemPriceBelowAnnual && <React.Fragment>
                    <i className="icon-down4"></i>
                    <span>{tMsg('Цена ниже среднегодовой')}</span>
                </React.Fragment>}
                {!isItemPriceBelowAnnual && <React.Fragment>
                    <i className="icon-quesion"></i>
                    <span dangerouslySetInnerHTML={{ __html: tMsg('Подробнее <br/> о цене') }} />
                </React.Fragment>}
            </a>
        </div>
    )
}
